import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const Clase3Component = styled.div`
  --survey-ink: #1a1a1a;
  --survey-muted: #5f6b76;
  --survey-line: #e6eef3;
  --survey-soft: #f3f9fc;
  --survey-accent: #3aa8d8;
  --survey-accent-deep: #2b8fbc;
  --survey-danger: #c0392b;
  --survey-radius: 14px;

  min-height: 100vh;
  background: radial-gradient(
      ellipse 80% 50% at 50% -10%,
      rgba(58, 168, 216, 0.14),
      transparent 55%
    ),
    linear-gradient(180deg, #f7fafc 0%, #eef3f7 100%);
  padding: 1.5rem 1rem 3rem;

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0.85rem 0.65rem 2.5rem;
  }

  .checkbox-container {
    .checkbox {
      display: block;
      margin: 10px 0;
      @media only screen and (max-width: 600px) {
        margin: 20px 0;
      }
    }
  }

  h1,
  h2,
  h3 {
    text-align: center;
    padding: 0;
    color: var(--survey-ink);
  }

  p {
    padding: 0;
  }

  .Questions.survey-shell {
    width: 100%;
    max-width: 860px;
    margin: 0 auto;
    min-width: 0;
    box-sizing: border-box;
  }

  .survey-content {
    background: #fff;
    border: 1px solid var(--survey-line);
    border-radius: 18px;
    box-shadow: 0 10px 40px rgba(26, 40, 54, 0.06);
    padding: 1.75rem 1.5rem 2rem;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;

    @media only screen and (max-width: ${screenSizes.tablet}) {
      padding: 1.25rem 1rem 1.5rem;
      border-radius: 14px;
    }

    @media only screen and (max-width: ${screenSizes.mobile}) {
      padding: 1rem 0.8rem 1.25rem;
      border-radius: 12px;
    }
  }

  .survey-page-header {
    text-align: center;
    margin-bottom: 1.25rem;

    .survey-eyebrow {
      margin: 0 0 0.35rem;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: var(--survey-accent-deep);
    }

    h1 {
      margin: 0;
      font-size: clamp(1.45rem, 3vw, 1.85rem);
      font-weight: 700;
      line-height: 1.2;
    }

    .survey-campus {
      margin: 0.45rem 0 0;
      color: var(--survey-muted);
      font-size: 0.95rem;
      font-weight: 600;
    }
  }

  .survey-empty {
    background: #fff;
    border-radius: 16px;
    padding: 2.5rem 1.5rem;
    text-align: center;
    border: 1px solid var(--survey-line);

    h1 {
      margin-bottom: 0.75rem;
    }

    p {
      color: var(--survey-muted);
      margin: 0;
    }
  }

  .survey-progress {
    margin-bottom: 1.5rem;

    &__meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.75rem;
      margin-bottom: 0.55rem;
    }

    &__label {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: var(--survey-ink);
    }

    &__count {
      font-size: 0.78rem;
      color: #888;
      white-space: nowrap;
    }

    &__bars {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      gap: 0.35rem;
    }

    &__bar {
      height: 4px;
      border-radius: 999px;
      background: #e8edf2;
      transition: background 0.2s ease;

      &.is-done {
        background: #7ec8e8;
      }

      &.is-current {
        background: var(--survey-accent);
      }
    }
  }

  .survey-step {
    &__header {
      text-align: left;
      margin-bottom: 1.25rem;

      h2 {
        text-align: left;
        font-size: clamp(1.25rem, 2.5vw, 1.55rem);
        font-weight: 700;
        margin: 0 0 0.5rem;
        line-height: 1.25;
      }

      p {
        margin: 0;
        color: var(--survey-muted);
        font-size: 0.95rem;
        line-height: 1.55;
      }
    }
  }

  .survey-intro-copy {
    background: var(--survey-soft);
    border: 1px solid #d8ecf5;
    border-radius: var(--survey-radius);
    padding: 1.1rem 1.15rem;
    margin-bottom: 1.5rem;

    p {
      margin: 0 0 0.75rem;
      color: var(--survey-ink);
      font-size: 1rem;
      line-height: 1.55;

      &:last-child {
        margin-bottom: 0;
        color: var(--survey-muted);
      }
    }
  }

  .intro {
    button {
      margin: 1rem auto 0;
      display: block;
    }
  }

  .scale-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;

    &__item {
      display: inline-flex;
      align-items: center;
      gap: 0.4rem;
      padding: 0.35rem 0.65rem;
      background: var(--survey-soft);
      border: 1px solid #d8ecf5;
      border-radius: 999px;
      font-size: 0.8rem;
      color: var(--survey-muted);
    }

    &__value {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 1.35rem;
      height: 1.35rem;
      padding: 0 0.25rem;
      border-radius: 999px;
      background: #fff;
      color: var(--survey-ink);
      font-weight: 700;
      font-size: 0.78rem;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    &__label {
      line-height: 1.2;
    }
  }

  .answer-progress {
    margin: 0 0 1.15rem;

    &__meta {
      display: flex;
      justify-content: space-between;
      font-size: 0.82rem;
      color: var(--survey-muted);
      margin-bottom: 0.4rem;
      font-weight: 600;
    }

    &__track {
      height: 6px;
      border-radius: 999px;
      background: #e8edf2;
      overflow: hidden;
    }

    &__fill {
      height: 100%;
      border-radius: inherit;
      background: linear-gradient(90deg, #7ec8e8, var(--survey-accent));
      transition: width 0.25s ease;
    }
  }

  .survey-alert {
    background: #fff6f6;
    border: 1px solid #e0b4b4;
    border-radius: 10px;
    padding: 0.85rem 1rem;
    margin-bottom: 1rem;
    color: var(--survey-danger);

    strong {
      display: block;
      margin-bottom: 0.25rem;
      font-size: 0.92rem;
    }

    p {
      margin: 0;
      font-size: 0.88rem;
      line-height: 1.45;
      color: #8a3b3b;
    }

    &__link {
      background: none;
      border: none;
      padding: 0;
      color: var(--survey-danger);
      font-weight: 700;
      cursor: pointer;
      text-decoration: underline;
      font-size: inherit;
    }
  }

  .survey-habeas {
    margin: 1rem 0;
    font-size: 0.85rem;
    color: var(--survey-muted);
    line-height: 1.45;
  }

  .survey-actions {
    position: sticky;
    bottom: 0.75rem;
    z-index: 5;
    margin-top: 1.5rem;
    padding: 0.85rem;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(8px);
    border: 1px solid var(--survey-line);
    border-radius: 14px;
    box-shadow: 0 8px 28px rgba(26, 40, 54, 0.1);
    text-align: center;

    &--top {
      position: static;
      margin-top: 0;
      margin-bottom: 1.25rem;
    }

    .ui.button.primary {
      width: 100%;
      max-width: 100%;
      font-size: 1rem !important;
      font-weight: 700 !important;
      padding: 1rem 1.5rem !important;
      border-radius: 999px !important;
      background: var(--survey-ink) !important;
      color: #fff !important;
      margin: 0 !important;

      &:hover {
        background: #333 !important;
      }
    }

    &__hint {
      margin: 0.55rem 0 0;
      font-size: 0.8rem;
      color: var(--survey-muted);
    }
  }

  .survey-questions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .survey-section-title {
    text-align: left;
    font-size: 1.05rem;
    font-weight: 700;
    margin: 1rem 0 0.35rem;
    color: var(--survey-ink);
  }

  .scale-hint {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.35rem;
    padding: 0 0.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #8896a3;
    text-transform: uppercase;
    letter-spacing: 0.04em;

    &__arrow {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, transparent, #c9d6e0, transparent);
    }
  }

  .survey-question {
    background: #fff;
    border: 1px solid var(--survey-line);
    border-radius: 12px;
    padding: 0.95rem 1rem;
    transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

    &.is-answered {
      border-color: #c5e8f5;
      background: #fbfdfe;
    }

    &.is-missing {
      border-color: #e0b4b4;
      background: #fffafa;
      box-shadow: 0 0 0 2px rgba(192, 57, 43, 0.08);
    }

    &__text {
      margin: 0 0 0.85rem;
      font-size: 0.98rem;
      line-height: 1.45;
      color: var(--survey-ink);
      display: flex;
      gap: 0.55rem;
      align-items: flex-start;
    }

    &__num {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 1.7rem;
      height: 1.7rem;
      border-radius: 8px;
      background: var(--survey-soft);
      color: var(--survey-accent-deep);
      font-size: 0.78rem;
      font-weight: 700;
    }

    &__options {
      display: flex;
      flex-wrap: wrap;
      gap: 0.45rem;
    }
  }

  .rating-pill {
    appearance: none;
    border: 1.5px solid #d5dee6;
    background: #fff;
    color: var(--survey-ink);
    min-width: 2.65rem;
    height: 2.65rem;
    padding: 0 0.65rem;
    border-radius: 999px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
      transform 0.15s ease;

    &:hover {
      border-color: var(--survey-accent);
      color: var(--survey-accent-deep);
    }

    &:focus-visible {
      outline: 2px solid var(--survey-accent);
      outline-offset: 2px;
    }

    &.is-selected {
      background: var(--survey-ink);
      border-color: var(--survey-ink);
      color: #fff;
      transform: scale(1.04);
    }

    @media only screen and (max-width: ${screenSizes.mobile}) {
      flex: 1 1 0;
      min-width: 0;
      height: 2.85rem;
    }
  }

  .initial-survey-form {
    max-width: 420px;
    margin: 0 auto;

    .initial-survey-form__label {
      display: block;
      text-align: center;
      font-size: 1.05rem;
      font-weight: 700;
      color: var(--survey-ink);
      margin-bottom: 1rem;
      line-height: 1.35;
    }

    .initial-survey-form__fields {
      display: grid;
      gap: 0.75rem;
    }

    .Registration__input {
      width: 100% !important;
      margin: 0 !important;
      box-sizing: border-box;
      border-radius: 10px !important;
      border: 1.5px solid #d5dee6 !important;
      padding: 0.9rem 1rem !important;
      font-size: 1rem !important;

      &:focus {
        border-color: var(--survey-accent) !important;
        outline: none;
        box-shadow: 0 0 0 3px rgba(58, 168, 216, 0.15);
      }
    }

    .error-message {
      color: var(--survey-danger);
      text-align: center;
      margin-top: 0.5rem;
      font-size: 0.88rem;
    }

    .Button,
    button {
      width: 100%;
      margin-top: 0.75rem;
    }
  }

  .quoteSending {
    text-align: center;
    padding: 2rem 1rem 1.5rem;

    .sending-spinner {
      width: 42px;
      height: 42px;
      margin: 0 auto 1.25rem;
      border: 3px solid #e8edf2;
      border-top-color: var(--survey-accent);
      border-radius: 50%;
      animation: survey-spin 0.8s linear infinite;
    }

    h2 {
      font-weight: 500;
      font-size: clamp(1.15rem, 3vw, 1.55rem);
      line-height: 1.45;
      max-width: 34rem;
      margin: 0 auto 0.75rem;
      color: var(--survey-ink);
    }

    .sending-verse {
      margin: 0 0 1.25rem;
      color: var(--survey-muted);
      font-size: 0.9rem;
      font-weight: 600;
    }

    .sending-status {
      margin: 0;
      font-size: 1rem;
      color: var(--survey-accent-deep);
      font-weight: 600;
    }
  }

  @keyframes survey-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .survey-results {
    min-width: 0;
    max-width: 100%;
    overflow-x: hidden;

    .previous-survey-badge {
      display: inline-flex;
      align-items: center;
      margin-bottom: 1rem;
      padding: 0.45rem 0.85rem;
      background: var(--survey-soft);
      border: 1px solid #d8ecf5;
      border-radius: 999px;
      font-size: 0.82rem;
      font-weight: 600;
      color: var(--survey-accent-deep);
      max-width: 100%;
      white-space: normal;
    }

    .survey-results-body {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      overflow-x: hidden;
      padding: 0;

      .result-section,
      .result-section.DISC,
      .result-section.spiritual,
      .result-section.connecting {
        padding: 1.15rem 1.15rem 1.25rem !important;
        box-sizing: border-box;
      }

      @media only screen and (max-width: ${screenSizes.tablet}) {
        .result-section,
        .result-section.DISC,
        .result-section.spiritual,
        .result-section.connecting {
          padding: 1rem 1rem 1.1rem !important;
        }
      }

      @media only screen and (max-width: ${screenSizes.mobile}) {
        .result-section,
        .result-section.DISC,
        .result-section.spiritual,
        .result-section.connecting {
          padding: 0.95rem 0.95rem 1.05rem !important;
        }
      }
    }

    @media only screen and (max-width: ${screenSizes.tablet}) {
      .survey-actions--top .ui.button.primary {
        font-size: 0.95rem !important;
        padding: 0.9rem 1.25rem !important;
      }
    }
  }

  .survey-retake {
    margin-top: 1.75rem;
    padding: 1.25rem 1.15rem;
    text-align: center;
    background: var(--survey-soft);
    border: 1px solid #d8ecf5;
    border-radius: var(--survey-radius);

    h3 {
      margin: 0 0 0.45rem;
      font-size: 1.1rem;
      font-weight: 700;
      color: var(--survey-ink);
      text-align: center;
    }

    p {
      margin: 0 0 1rem;
      color: var(--survey-muted);
      font-size: 0.92rem;
      line-height: 1.45;
    }

    .ui.button.primary {
      background: var(--survey-ink) !important;
      color: #fff !important;
      border-radius: 999px !important;
      font-weight: 700 !important;
      padding: 0.9rem 1.5rem !important;

      &:hover {
        background: #333 !important;
      }
    }
  }

  .disc {
    .additional-questions-form {
      max-width: 800px;
      margin: 0 auto;

      & > div {
        margin-bottom: 25px;
      }

      .form-section {
        background: white;
        border-radius: 10px;
        padding: 25px;
        margin-bottom: 25px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        border: 1px solid #e9ecef;

        h2 {
          color: #34495e;
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 20px;
          text-align: left;
          padding: 0;
          display: flex;
          align-items: center;
          gap: 10px;

          &:before {
            font-size: 24px;
          }
        }

        .form-field {
          margin-bottom: 20px;

          label {
            display: block;
            font-weight: 500;
            color: #2c3e50;
            margin-bottom: 8px;
            font-size: 15px;
            line-height: 1.4;

            &.error {
              color: #e74c3c;
              font-weight: 600;
            }
          }

          .ui.input {
            width: 100%;

            input {
              border-radius: 8px !important;
              border: 2px solid #e9ecef !important;
              padding: 12px 16px !important;
              font-size: 15px !important;
              transition: all 0.2s ease !important;

              &:focus {
                border-color: #3498db !important;
                box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1) !important;
              }

              &.error {
                border-color: #e74c3c !important;
                box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1) !important;
              }
            }
          }

          .ui.dropdown {
            width: 100%;

            .text {
              padding: 12px 16px;
              font-size: 15px;
            }

            .menu {
              border-radius: 8px;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              border: 1px solid #e9ecef;

              .item {
                padding: 12px 16px;
                font-size: 15px;

                &:hover {
                  background: #f8f9fa;
                }
              }
            }
          }

          .checkbox-container {
            background: #f8f9fa;
            border-radius: 8px;
            padding: 15px;
            border: 1px solid #e9ecef;

            .ui.checkbox {
              margin: 8px 0;

              label {
                font-size: 14px;
                color: #495057;
                padding-left: 30px;
                line-height: 1.4;
              }
            }
          }
        }

        .children-ages-section {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 20px;
          margin: 15px 0;
          border: 1px solid #e9ecef;

          p {
            text-align: left;
            color: #495057;
            font-weight: 500;
            margin-bottom: 15px;
          }

          .age-inputs {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;
          }
        }

        .age-input {
          display: flex;
          align-items: center;
          gap: 10px;

          label {
            font-size: 14px;
            color: #495057;
            margin: 0;
            flex: 1;
          }

          input {
            width: 80px;
            text-align: center;
          }
        }

        .leadership-assessment {
          background: linear-gradient(135deg, #3aa8d8 0%, #2b8fbc 100%);
          color: white;
          border-radius: 10px;
          padding: 20px;
          margin: 20px 0;

          p {
            color: white;
            text-align: left;
            margin-bottom: 15px;
            font-weight: 500;
          }

          .assessment-inputs {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 15px;
          }
        }

        .assessment-input {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          padding: 15px;
          backdrop-filter: blur(10px);

          label {
            color: white;
            font-size: 14px;
            margin-bottom: 8px;
            display: block;
          }

          input {
            width: 100%;
            background: rgba(255, 255, 255, 0.9);
            border: none;
            border-radius: 6px;
            padding: 8px 12px;
            text-align: center;
            font-weight: 600;
            color: #2c3e50;

            &:focus {
              background: white;
              box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
            }
          }
        }
      }
    }
  }

  /* Keep guest registration form readable inside the new shell */
  .survey-step .RegistrationForm,
  .survey-step form.ui.form {
    padding: 0;
    margin: 0;
  }

  @media only screen and (max-width: ${screenSizes.desktop}) {
    .disc .additional-questions-form {
      .form-section {
        padding: 20px;

        .children-ages-section .age-inputs,
        .leadership-assessment .assessment-inputs {
          grid-template-columns: 1fr;
        }

        .age-input {
          flex-direction: column;
          align-items: flex-start;
          gap: 5px;

          input {
            width: 100%;
          }
        }
      }
    }
  }
`;
